import React from "react";
import About from "../components/About";

import Banner from "../components/Banner";
import Contact from "../components/Contact";
// import Modal from "../components/Modal";

const Home = () => {
    return (
        <div>
            <Banner />
            <About />

            <Contact />
            {/* <Modal/> */}
        </div>
    );
};

export default Home;
